import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    authenticateUser,
    authenticatedUser,
    failedAuthenticateUser
} from "actions";
import uuid from "uuid/v4";
import { Map } from "immutable";
import { Alert, Icon } from "antd";
import { Layout, Row, Col, message, Button } from "antd";
import { AuthForm, ForgotNewPasswordForm, ForgotPasswordEmailForm } from "forms";
import { AuthService } from "services";
import { XHR_ERRORS } from "constants";

class AuthView extends React.Component {
    formID = uuid();
    state = {
        formSubmitting: false,
        authError: null,
        values: null,
        invalidCredentialsErrorVisible: false,
        showForgotPasswordForm: false,
        passwordEntryForm: false,
        emailEntryForm: false,
        showBankMessage: false,
        userEmail: null,
        password: null
    };
    componentWillMount() {
        if (AuthService.isAuthenticated()) {
            this.props.history.replace("/app");
        }
    }
    authenticate = values => {
        this.props.authenticateUser();
        this.setState(
            {
                formSubmitting: true,
                authError: null,
                values: new Map(values)
            },
            () =>
                AuthService.authenticate(values.username, values.password, values.recaptchaToken, values.microsoftAuthResponse).then(
                    ({ error }) => {
                        if (error) {
                            this.props.failedAuthenticateUser();
                            switch (error) {
                                case XHR_ERRORS.NETWORK_ERROR:
                                    message.warning("No Internet Access", 5);
                                    return;
                                case XHR_ERRORS.SERVICE_DOWN:
                                    message.warning(
                                        "Please try again after sometime."
                                    );
                                    return;
                                case XHR_ERRORS.INVALID_CREDENTIALS:
                                    setTimeout(() => this.setState({
                                        authError: "It seems you entered an incorrect password",
                                        invalidCredentialsErrorVisible: true,
                                        formSubmitting: false
                                    }), 1000);
                                    return;
                                default:
                                    return;
                            }
                        } else {
                            this.props.history.replace("/app");
                        }
                    }
                ).catch((err) => {
                    const { error, attemps_left } = err;
                    if (error == "Access Denied, Redirecting to onboarding portal.") {
                        this.redirectToOnboarding();
                    }
                    else if (error == "invalid_grant") {
                        if (attemps_left !== null && attemps_left !== undefined) {
                            setTimeout(() => this.setState({
                                formSubmitting: false,
                                authError: (
                                    <div>
                                        <span>It seems you entered an incorrect password</span><br />
                                        <span>{attemps_left || 0} Attempts Left</span>
                                    </div>
                                ),
                                invalidCredentialsErrorVisible: true
                            }), 2000);

                        } else {
                            setTimeout(() => this.setState({
                                formSubmitting: false,
                                authError: (
                                    <div>
                                        <span>User not found or inactive. Please contact administrator.</span>
                                    </div>
                                ),
                                invalidCredentialsErrorVisible: true
                            }), 2000);
                        }

                    }
                    if(error && error[0] == "missing-input-response") {
                        setTimeout(() => this.setState({
                            formSubmitting: false,
                            authError: <div><span>It seems you are trying to login with wrong Credentials</span><br /><span>{attemps_left || 0} Attempts Left</span></div>,
                            invalidCredentialsErrorVisible: true
                        }), 2000);
                    } else if(error == "You are lockedout.Please try after some time.") {
                        setTimeout(() => this.setState({
                            formSubmitting: false,
                            authError: "Due to multiple login attempts failure,You are lockedout from the system, Please try after 15 Minutes",
                            invalidCredentialsErrorVisible: true
                        }), 2000);
                    }else {
                        setTimeout(() => this.setState({
                            formSubmitting: false,
                            authError: <div><span>It seems you entered an incorrect password</span><br /><span>{attemps_left || 0} Attempts Left</span></div>,
                            invalidCredentialsErrorVisible: true
                        }), 2000);
                    }
                })
        );
    };


    openForgotPasswordWindow = () => {
        this.setState({
            showForgotPasswordForm: true,
            emailEntryForm: true
        });
    }

    renderAlert() {
        if (this.state.invalidCredentialsErrorVisible) {
            return (
                <Alert
                    message="Invalid Credentials"
                    type="warning"
                    closable
                    onClose={() =>
                        this.setState({ invalidCredentialsErrorVisible: false })
                    }
                />
            );
        }
        return null;
    }

    showEmailEntryForm = () => {
        this.setState({
            emailEntryForm: true
        });
    }

    sendOtp = (values) => {
        this.setState({
            emailEntryForm: false,
            username: values.email,
            passwordEntryForm: true
        });
        AuthService.sendOtp(values.email);
    }

    changePassword = (values) => {
        AuthService.changePassword({...values, email: this.state.username}).then(({data, error}) => {
            if(data) {
                message.success("Password Changed Successfully");
                this.setState({
                    passwordEntryForm: false,
                    showForgotPasswordForm: false
                });
            } else if(error) {
                message.error("Failed to change Password");
            }
        });
    }

    redirectToLosDesk = (userEmail) => {
        message.loading({ content: "Redirecting to LOS Desk", key: "updatable" });
        setTimeout(() => {
            window.location.replace(`https://los-desk.progcap.com?username=${userEmail}`, {
                username: this.state.userEmail,
                password: this.state.password
            });    
        }, 5000);
        
    }

    redirectToOnboarding = (userEmail) => {
        message.loading({ content: "Redirecting to Onboarding Portal", key: "updatable" });
        setTimeout(() => {
            window.location.replace(`https://onboarding.progcap.com?username=${userEmail}`, {
                username: this.state.userEmail,
                password: this.state.password
            });
        }, 5000);
    }

    render() {
        return (
            <React.Fragment>
                <Layout>
                    <Row
                        type="flex"
                        justify="center"
                        align="middle"
                        className={"vh-100"}>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={8} xs={12}>
                            {!this.state.showForgotPasswordForm && !this.state.emailEntryForm && !this.state.passwordEntryForm ?
                                <React.Fragment>
                                    <AuthForm
                                        id={this.formID}
                                        submitValues={this.authenticate}
                                        formSubmitting={this.state.formSubmitting}
                                        values={this.state.values}
                                        askBankUser={this.redirectToLosDesk}
                                    />
                                    <div className={"d-flex justify-content-space-between align-items-center flex-row-reverse flex-wrap"}>
                                        <Button 
                                            type={"link"} 
                                            onClick={this.openForgotPasswordWindow} 
                                            style={{
                                                textAlign: "right"
                                            }}
                                        >
                                            Forgot Password?
                                        </Button>
                                        <div style={{flexGrow: 1}}>
                                            {this.state.authError ?
                                                <p className={"mb-0 d-flex align-items-center"} style={{ color: "red"}}>
                                                    <Icon type={"exclamation-circle"} className={"mr-5"} color={"red"} />{" "}
                                                    {this.state.authError}
                                                </p> : null
                                            }
                                        </div>
                                    </div>
                                    

                                </React.Fragment>
                                : this.state.showForgotPasswordForm && this.state.emailEntryForm && !this.state.passwordEntryForm ? (
                                    <ForgotPasswordEmailForm 
                                        submitValues={this.sendOtp}
                                    />
                                ): (
                                    <ForgotNewPasswordForm 
                                        submitValues={this.changePassword}
                                    />
                                )}
                        </Col>
                    </Row>
                </Layout>
                {this.renderAlert()}
            </React.Fragment>
        );
    }
}

AuthView.propTypes = {
    location: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object,
    authenticateUser: PropTypes.func,
    failedAuthenticateUser: PropTypes.func
};

const mapStateToProps = state => {
    return { auth: state.auth };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            authenticateUser,
            authenticatedUser,
            failedAuthenticateUser
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AuthView);
